<template>
  <div>
    <b-modal ref="modal" header-class="border-bottom-0" size="xl" no-close-on-backdrop>
      <template v-slot:modal-title>
        <avatar
          inline
          color="#fff"
          :size="30"
          :username="name"
          :initials="name.slice(0, 1)"
        ></avatar>
        <span style="margin-left: 10px">{{ name }}</span>
      </template>
      <div class="container-fluid">
        <b-tabs v-model="tabs" pills content-class="mt-3">
          <b-tab active>
            <template v-slot:title>
              <i class="fas fa-folder-open"></i> Em Aberto
            </template>
            <bill-receiveble-open-list
              :id="this.searchForm.id"
              ref="BillReceivebleOpenList"
              @mutated="onMutate($event)"
            />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <i class="fas fa-folder"></i> Contas Pagas
            </template>
            <bill-receiveble-payed-list
              ref="BillReceiveblePayedList"
              :id="this.searchForm.id"
            />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <i class="fas fa-ban"></i> Canceladas
            </template>
            <bill-receiveble-cancel-list
              ref="BillReceivebleCancelList"
              :id="this.searchForm.id"
            />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <i class="fas fa-archive" /> Arquivadas
            </template>
            <BillReceivebleArchiveList
              ref="BillReceivebleArchiveList"
              :id="this.searchForm.id"
            />
          </b-tab>
        </b-tabs>
      </div>
      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Voltar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import moment from "moment";
import TablePaginator from "../../sections/TablePaginator.vue";
import InfoCard from "../../sections/dashboard/InfoCard.vue";
import BillReceivebleOpenList from "../lists/BillReceivebleOpenList.vue";
import BillReceiveblePayedList from "../lists/BillReceiveblePayedList.vue";
import BillReceivebleCancelList from "../lists/BillReceivebleCancelList.vue";
import BillReceivebleArchiveList from "../lists/BillReceivebleArchiveList.vue";

export default {
  components: {
    Avatar,
    TablePaginator,
    InfoCard,
    BillReceivebleOpenList,
    BillReceiveblePayedList,
    BillReceivebleCancelList,
    BillReceivebleArchiveList,
  },

  data: function () {
    return {
      searchForm: {
        id: null,
        name: null,
      },

      name: {},

      bills: {},

      tabs:0,
    };
  },

  watch: {
    tabs: {
      
      deep: true,
      handler(newValue, oldValue) {      

        if(this.tabs == 0){
          this.$refs.BillReceivebleOpenList.select() 
        }

        if(this.tabs == 1){
          this.$refs.BillReceiveblePayedList.select() 
        }

        if(this.tabs == 2){
          this.$refs.BillReceivebleCancelList.select() 
        }

        if(this.tabs == 3){
          this.$refs.BillReceivebleArchiveList.select() 
        }
      }
    }
  },

  methods: {
    open(row) {
      this.searchForm.id = row.person_id;

      this.name = row.name;

      this.$refs.modal.show();
    },

    onMutate(event) {
      this.$emit("update");
      this.refresh();
    },

    getDueDateBadge(date, status) {
      if (this.isOverDue(date) && status == "o") {
        return "badge-danger";
      }
      return "badge-primary";
    },

    isOverDue(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").isBefore(
        moment().subtract(1, "days")
      );
    },
    refresh() {
      this.$refs.BillReceiveblePayedList.select();
      this.$refs.BillReceivebleCancelList.select();
    },
  },
};
</script>

<style>
</style>
